/**
 * ZZAI gift card PDP — amount pills, live price, quantity stepper.
 */
(function () {
  'use strict';

  function fmt(cents) {
    if (window.ZZAI?.fmt) return window.ZZAI.fmt(cents);
    const n = Number(cents) || 0;
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(
      n / 100
    );
  }

  function syncAmountPills(form) {
    form.querySelectorAll('.gc-amount-opt').forEach((label) => {
      const input = label.querySelector('input[name="id"]');
      label.classList.toggle('is-active', !!(input && input.checked));
    });
  }

  function updatePrice(form, root) {
    const priceEl = root.querySelector('[data-gc-price]');
    if (!priceEl) return;
    const checked = form.querySelector('input[name="id"]:checked');
    const hidden = form.querySelector('input[name="id"][type="hidden"]');
    const cents = parseInt(checked?.dataset?.priceCents || hidden?.dataset?.priceCents || '0', 10);
    if (cents > 0) priceEl.textContent = fmt(cents);
  }

  function syncSubmit(form) {
    const submit = form.querySelector('[data-gc-submit]');
    if (!submit) return;
    const checked = form.querySelector('input[name="id"]:checked');
    if (checked) {
      submit.disabled = !!checked.disabled;
      return;
    }
    const hidden = form.querySelector('input[name="id"][type="hidden"]');
    if (hidden) submit.disabled = !!hidden.disabled;
  }

  function bindQty(wrap) {
    const input = wrap.querySelector('[data-gc-qty-input]');
    if (!input) return;
    wrap.querySelector('[data-gc-qty-dec]')?.addEventListener('click', () => {
      const v = parseInt(String(input.value), 10);
      const n = Number.isFinite(v) ? v : 1;
      input.value = String(Math.max(1, n - 1));
    });
    wrap.querySelector('[data-gc-qty-inc]')?.addEventListener('click', () => {
      const v = parseInt(String(input.value), 10);
      const n = Number.isFinite(v) ? v : 1;
      input.value = String(n + 1);
    });
  }

  function init(root) {
    root.querySelectorAll('.gc-product-form').forEach((form) => {
      syncAmountPills(form);
      syncSubmit(form);
      updatePrice(form, root);

      form.querySelectorAll('input[name="id"]').forEach((el) => {
        el.addEventListener('change', () => {
          syncAmountPills(form);
          syncSubmit(form);
          updatePrice(form, root);
        });
      });

      form.querySelectorAll('[data-gc-qty]').forEach(bindQty);
    });
  }

  function boot() {
    document.querySelectorAll('.zzai-gift-card-main').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
